export const TabPanel = ({ value, index, children }) => {
  if (value === index) {
    return children;
  } else {
    return null;
  }
};
